import { useWallets } from '@privy-io/react-auth';
import { useUserStore } from '@/app/stores/useUserStore';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * 合约交易专用的钱包 Hook
 * 封装了 Privy wallet 的获取和 provider 操作
 */
export const usePerpsWallet = () => {
  const { evmAddress } = useUserStore();
  const { wallets } = useWallets();
  const { t } = useTranslation();

  // 根据 evmAddress 匹配对应的钱包
  const evmWallet = useMemo(() => {
    if (!evmAddress) return wallets[0];
    return wallets.find(w => w.address?.toLowerCase() === evmAddress.toLowerCase()) || wallets[0];
  }, [wallets, evmAddress]);

  /**
   * 获取 EIP-1193 provider
   * 用于所有 RPC 调用（eth_chainId, eth_signTypedData_v4 等）
   */
  const getProvider = async () => {
    if (!evmWallet) {
      throw new Error(t('wallet.walletNotReady'));
    }
    return await evmWallet.getEthereumProvider();
  };

  /**
   * 切换链
   * @param chainId 链 ID（例如：42161 for Arbitrum）
   */
  const switchChain = async (chainId: number) => {
    if (!evmWallet) {
      throw new Error(t('wallet.walletNotReady'));
    }
    await evmWallet.switchChain(chainId);
  };
  
  return {
    evmWallet,        // Privy 钱包实例
    evmAddress,       // 用户的 EVM 地址
    getProvider,      // 获取 EIP-1193 provider 的方法
    switchChain,      // 切换链的方法
    isReady: !!evmWallet && !!evmAddress, // 钱包是否就绪
  };
};

